import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { ModuleService } from '../module.service';
import { IAddModulPayload, IModulForm } from '../module.interface';

@Component({
    selector: 'app-add-modul',
    templateUrl: './add-modul.component.html',
    styleUrls: ['./add-modul.component.scss']
})
export class AddModulComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    // defaultParameter: { name: string; id: string } = {
    //     name: '--Alegeți--',
    //     id: '-1',
    // };

    durataOptions: { name: string; value: number }[] = [
        { name: '--Alegeți--', value: -1 },
        { name: '5 minute', value: 5 },
        { name: '10 minute', value: 10 },
        { name: '15 minute', value: 15 },
        { name: '20 minute', value: 20 },
        { name: '25 minute', value: 25 },
        { name: '30 minute', value: 30 },
        { name: '35 minute', value: 35 },
        { name: '40 minute', value: 40 },
        { name: '45 minute', value: 45 },
        { name: '50 minute', value: 50 },
        { name: '55 minute', value: 55 },
        { name: '60 minute', value: 60 },
    ]

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        observatii: new FormControl('', []),
        durata_programare: new FormControl('', [Validators.required, Validators.min(0)]),
        durata_interval_blocare: new FormControl('', [Validators.required, Validators.min(0)]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddModulComponent>,
        private moduleService: ModuleService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, observatii, durata_programare, durata_interval_blocare } = this.form.value as IModulForm;
        const payload: IAddModulPayload = {
            name,
            observatii,
            durata_programare,
            durata_interval_blocare
        };

        this.moduleService
            .addModul(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
